import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/components/login.component';
import { ApplicationsComponent } from './reporting/components/applications.component';
import { SiteTrafficComponent } from './reporting/components/site-traffic.component';
import { ApplicationsPendingComponent } from './applications/components/applications-pending.component';
import { ApplicationsCallbackComponent } from './applications/components/applications-callback.component';
import { ApplicationsResolvedComponent } from './applications/components/applications-resolved.component';
import { ApplicationDetailsComponent } from './applications/components/application-details.component';
import { DownloadsComponent } from './downloads/components/downloads.component';

const APP_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login',
        component: LoginComponent
    },
    {
        path: 'reporting/applications',
        component: ApplicationsComponent
    },
    {
        path: 'reporting/site-traffic',
        component: SiteTrafficComponent
    },
    {
        path: 'applications/pending',
        component: ApplicationsPendingComponent
    },
    {
        path: 'applications/call-back',
        component: ApplicationsCallbackComponent
    },
    {
        path: 'applications/resolved',
        component: ApplicationsResolvedComponent
    },
    {
        path: 'applications/application-details',
        component: ApplicationDetailsComponent
    },
    {
        path: 'downloads',
        component: DownloadsComponent
    }
];

export const AppRoutingModule = RouterModule.forRoot(APP_ROUTES, { useHash: true });
